"use client";
'use strict';

var React = require('react');
require('../utils/assertion.js');
var iframeModalResize = require('../utils/iframeUtils/iframeModalResize.js');
var isIframe = require('../utils/iframeUtils/isIframe.js');
var usePrevious = require('./usePrevious.js');

/**
 * Используется для управления размером модального окна в iframe, при его открытии или закрытии.
 * Фиксит проблему, когда при открытии модального окна iframe-resizer не реагирует на это и не изменяет размеры iframe.
 *
 * @param {IResizeIframeModal} params - Параметры для настройки ресайза iframe модального окна.
 * @param {boolean | undefined} params.shouldResize - Параметр управляет необходимостью ресайза iframe.
 * @param {boolean | undefined} params.visible - Параметр видимости модального окна.
 * @returns {void}
 */
const useResizeIframeModal = ({ shouldResize, visible }) => {
    const prevVisible = usePrevious.usePrevious(visible);
    const isResized = React.useRef(false);
    React.useEffect(() => {
        if (isIframe.isIframeWithIframeResizer() && shouldResize && visible !== prevVisible) {
            if (visible) {
                isResized.current = true;
                iframeModalResize.resizeModal();
            }
            else if (isResized.current) {
                isResized.current = false;
                iframeModalResize.restoreModalSize();
            }
        }
    }, [visible, shouldResize, prevVisible]);
    React.useEffect(() => () => {
        if (isIframe.isIframeWithIframeResizer() && isResized.current) {
            iframeModalResize.restoreModalSize();
        }
    }, []);
};

exports.useResizeIframeModal = useResizeIframeModal;
//# sourceMappingURL=useResizeIframeModal.js.map
